module.exports = __webpack_public_path__ + "resources/img/img-hyper-frame-nginx-03-m.6d6aa6406190ac4683c6dccc3ba79b33.png";